import { IListApiRequest, IListApiResponse } from 'api/types'

export enum TransactionStatus {
  COMPLETED = 'payment-accepted',
  REJECTED = 'payment-rejected',
  OTHER = 'status-other'
}

export enum PaymentStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Cancelled = 'Cancelled',
  TimedOut = 'timedout'
}

export type PaymentError = {
  error?: {
    metadata?: {
      order_id?: string,
      payment_id?: string
    }
  }
}

export enum Currency {
  INR = 'INR',
  USD = 'USD',
  EUR = 'EUR'
}

export interface wallet {
  id?: string;
  amount?: string;
  name?: string;
  channel?: string;
  type?: string;
  paymentId?: string;
  campaign?: string;
  subsId?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  transactionType?: string;
  createdDate?: string;
}
export type payment = {
  id: string,
  currency: Currency,
  amount: string,
  totalBalance?: string,
  spendBalance?: string,
  holdBalance?: string,
  razorpay_payment_id?: string,
  razorpay_order_id?: string,
  razorpay_signature?: string
}

export interface orderPaymentDetails {
  orderId: string | null;
  currency: Currency;
  amount: string | null;
}

export type CreateOrderResponse = payment
export type WalletListRequest = IListApiRequest<wallet>
export type WalletListResponse = IListApiResponse<wallet>
